/**
 * `displayConfig.badge` (template definition + optional per-mapping override via merge):
 * @typedef {object} SupplementalDisplayBadge
 * @property {boolean} show — When true, board layout may show a count chip when data is loaded.
 * @property {string} [icon] — Key from {@link ICON_NAMES} (e.g. list, note, queryStats).
 * @property {object} [style] — React style object applied to the badge wrapper (e.g. { color: 'var(--color-primary-500)' }).
 * @property {string} [label] — Text shown after the count (default "item", pluralized automatically).
 */

import { ICON_NAMES } from '../../../../../constants'

export function resolveSupplementalBadgeIconName (iconKey) {
  if (iconKey == null || iconKey === '') return ICON_NAMES.list
  const k = String(iconKey).trim()
  if (ICON_NAMES[k]) return ICON_NAMES[k]
  return ICON_NAMES.list
}
